<template>
  <v-container fluid fill-height>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card class="elevation-12">
          <v-toolbar dark color="light-blue">
            <v-toolbar-title>Login</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container fluid>
            <v-card-text>
              <v-text-field prepend-icon="email" name="email" label="Email" type="text" v-model="email"></v-text-field>
              <v-text-field prepend-icon="lock" name="password" label="Password" type="password" v-model="password"></v-text-field>
            </v-card-text>
            <v-spacer></v-spacer>
            <v-btn class="blue lighten-2 mt-4" dark v-on:click="login()">Login</v-btn>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {EventBus} from '@/event-bus.js'
  export default {
    data () {
      return {
        email: '',
        password: ''
      }
    },
    methods: {
      login: function () {
        if(this.email==='' || this.password === '') {
          EventBus.$emit('send-notification', {text: 'Missing required fields'});
          return;
        }
        this.$http.post(this.$store.state.serverHttpUrl+'/login', {
          email: this.email,
          password: this.password
        }).then(function (response) {
          this.$session.start()
          this.$store.dispatch('setEmail', this.email)
          this.$store.dispatch('setToken', response.body)
          this.$store.dispatch('setUser', response.body)
          EventBus.$emit('send-notification', {text: 'Login successful', color: 'success'});
          this.$router.push('/');
        }, function (err) {
          EventBus.$emit('send-notification', {text: err.body});
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Login/AppLogin.vue